import * as React from 'react'
import { SVGProps } from 'react'
const SVGPanBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={92}
    height={76}
    viewBox='0 0 92 76'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width={92} height={60} rx={6} fill='#DEE2E9' />
    <rect opacity={0.5} x={36} y={23} width={48} height={6} rx={2} fill='#8E94A0' />
    <rect opacity={0.5} x={8} y={44} width={76} height={6} rx={2} fill='#8E94A0' />
    <rect opacity={0.5} x={36} y={11} width={19} height={6} rx={2} fill='#8E94A0' />
    <rect opacity={0.5} x={59} y={11} width={25} height={6} rx={2} fill='#8E94A0' />
    <rect opacity={0.5} x={8} y={8} width={22} height={24} rx={2} fill='#8E94A0' />
    <circle cx={46} cy={55} r={18} fill='white' />
    <path
      d='M40.96 62L46 56.96L51.04 62L53 60.04L47.96 55L53 49.96L51.04 48L46 53.04L40.96 48L39 49.96L44.04 55L39 60.04L40.96 62ZM46 69C44.0633 69 42.2433 68.6325 40.54 67.8975C38.8367 67.1625 37.355 66.165 36.095 64.905C34.835 63.645 33.8375 62.1633 33.1025 60.46C32.3675 58.7567 32 56.9367 32 55C32 53.0633 32.3675 51.2433 33.1025 49.54C33.8375 47.8367 34.835 46.355 36.095 45.095C37.355 43.835 38.8367 42.8375 40.54 42.1025C42.2433 41.3675 44.0633 41 46 41C47.9367 41 49.7567 41.3675 51.46 42.1025C53.1633 42.8375 54.645 43.835 55.905 45.095C57.165 46.355 58.1625 47.8367 58.8975 49.54C59.6325 51.2433 60 53.0633 60 55C60 56.9367 59.6325 58.7567 58.8975 60.46C58.1625 62.1633 57.165 63.645 55.905 64.905C54.645 66.165 53.1633 67.1625 51.46 67.8975C49.7567 68.6325 47.9367 69 46 69Z'
      fill='#CA0024'
    />
  </svg>
)
export default SVGPanBlock
